import validatePaidCampaign from '@helpers/validatePaidCampaign';
import Image from 'next/future/image';
import React from 'react';
import localizationData from '../../data/lpLocalizationData';
import AppointmentSchedulerComponent from '../AppointmentSchedulerV2/AppointmentSchedulerComponent';
import { JoinNowStyles } from './JoinNowStyles';
import { WordPressAPI } from '@/config';

const CalendarComponentV2 = ({
  close,
  handleNextStep,
  stage,
  campaign,
  data,
  submitting,
  PaidCampaign,
  EntityCampaign = false,
  localizationStrings = localizationData.en,
  setCurrentStep = false,
  setIsLoading = false,
  customClass = false,
  NumDaysOverride = null,
  isTaxServicesLLC,
  errorMessage = null,
  EForm = false,
}) => {

  PaidCampaign = validatePaidCampaign(PaidCampaign);
  let title, sub_title, additional_copy;
  if (isTaxServicesLLC) {
    title = 'Schedule Your Free Call';
    sub_title =
      'Talk to an LLC tax services expert.';
    additional_copy =
      'Select a time and we’ll give you a call.';
  } else {
    title = 'Accounting for Everything';
    sub_title =
      'Nationwide tax and accounting services for small businesses, provided by local CPAs.';
    additional_copy =
      'Choose a time that works for you, provide some basic info, and we’ll give you a call.';
  }

  const testimonialText = '"Excellent first call, very informative. This is my third business... this time I will ease the burden and use 1-800Accountant [for accounting]"'


  let is_stimulus = false;

  let accountant_details = {
    image: {
      url: '/static/images/Susan_Young_color.png',
      alt: 'Susan Young',
    },
    name: 'Susan Young',
    job_title: '1-800Accountant Specialist',
  };

  let paid_campaign = PaidCampaign;
  if (data) {
    ({
      // title,
      // sub_title,
      // additional_copy,
      accountant_details,
      paid_campaign,
      is_stimulus,
    } = data);
  }
  return (
    <JoinNowStyles className={customClass}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            <div className="sub-message">Select a time and we’ll give you a call</div>
          </div>
        </div>
      </div>
      {errorMessage ? <div className='error-message'>
        <img src="/icons/danger.png" alt="danger icon" width="50px" height="50px" /> {errorMessage}
      </div> : ''}
      <div>
        <AppointmentSchedulerComponent
          close={close}
          handleNextStep={handleNextStep}
          mode="slideup"
          PaidCampaign={PaidCampaign}
          EntityCampaign={EntityCampaign}
          isStimulus={is_stimulus ? '1' : '0'}
          stage={stage}
          campaign={campaign}
          submitting={submitting}
          appointmentText={localizationStrings.appointmentText}
          confirmText={localizationStrings.confirmText}
          setCurrentStep={setCurrentStep}
          setIsLoading={setIsLoading}
          NumDaysOverride={NumDaysOverride}
          EForm={EForm}
        />
      </div>

      <div className="container">
          <div className='scheduler-testimonial col-12 col-md-10'>
            <img src={`${WordPressAPI.media}/2022/07/huong-t.png`} alt="Huong T - Testimonial image"/>
            <div>
              <div className='text'>{testimonialText}</div>
              <div className='author'>Huong T.</div>
            </div>
        </div>
      </div>

    </JoinNowStyles>
  );
};

export default CalendarComponentV2;
